import { chatApiAxios } from "@/plugins";
import { HttpRequestMethodEnum } from "@/types/api";

interface LeaveChat {
  chatId: string;
  accessToken: string;
}

export const leaveChatBeAsync = async ({ chatId, accessToken }: LeaveChat) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const res = await chatApiAxios("chat/" + chatId + "/leave", {
    method: HttpRequestMethodEnum.DELETE,
    headers,
  });
  return res.data;
};
